import i18n from "@/i18n";

class Validations {
  productionUnitNameMaxLength = 100;

  getProductionUnitAvailableUnits() {
    return [
      { id: "unit", name: i18n.t("common.units.unit") },
      { id: "case", name: i18n.t("common.units.case") },
      { id: "pack", name: i18n.t("common.units.pack") },
      { id: "bottle", name: i18n.t("common.units.bottle") },
      { id: "box", name: i18n.t("common.units.box") },
      { id: "cycle", name: i18n.t("common.units.cycle") },
      { id: "bag", name: i18n.t("common.units.bag") },
      { id: "pallet", name: i18n.t("common.units.pallet") },
      { id: "kilogram", name: i18n.t("common.units.kilogram") },
      { id: "ton", name: i18n.t("common.units.ton") },
      { id: "pound", name: i18n.t("common.units.pound") },
      { id: "ounce", name: i18n.t("common.units.ounce") },
      { id: "meter", name: i18n.t("common.units.meter") },
      { id: "feet", name: i18n.t("common.units.feet") },
      { id: "liter", name: i18n.t("common.units.liter") },
    ];
  }
  getDefaultUnit() {
    return "unit";
  }
  isProductionUnitNameValid(value) {
    return /^(?:(?![×Þß÷þø])[-_ 0-9a-zÀ-ÿ])+$/.test(String(value).toLowerCase());
  }
  isProductionUnitObjectiveValid(value) {
    return /^[1-9]{1}\d{0,1}[.]{0,1}\d{0,1}$/.test(value);
  }
  isProductionUnitQualityValid(value) {
    return /^[0-9]{1}\d{0,1}[.]{0,1}\d{0,1}$/.test(value);
  }
  isProductionUnitConvertedUnitValid(unitId) {
    const found = this.getProductionUnitAvailableUnits().filter((u) => unitId === u.id);
    return found && found.length === 1;
  }

  downtimeCategoryCodeMaxLength = 5;
  downtimeCategoryNameMaxLength = 100;
  downtimeReasonCodeMaxLength = 5;
  downtimeReasonNameMaxLength = 100;

  isDowntimeCategoryCodeValid(value) {
    return /^[a-zA-Z0-9-_/|()[\]{}<>]+$/.test(String(value));
  }
  isDowntimeCategoryNameValid(value) {
    const withoutEmojis = this.getValueWithoutEmojis(value);
    if (value.length > 0 && withoutEmojis.length == 0) {
      return true;
    }
    return /^(?:(?![×Þß÷þø])[-_.,'\\/#%&| 0-9a-zÀ-ÿ()[\]{}<>œ…°])+$/.test(String(withoutEmojis).toLowerCase());
  }
  isDowntimeReasonCodeValid(value) {
    return /^[a-zA-Z0-9-_/|()[\]{}<>]+$/.test(String(value));
  }
  isDowntimeReasonNameValid(value) {
    const withoutEmojis = this.getValueWithoutEmojis(value);
    if (value.length > 0 && withoutEmojis.length == 0) {
      return true;
    }
    return /^(?:(?![×Þß÷þø])[-_.,'\\/#%&| 0-9a-zÀ-ÿ()[\]{}<>œ…°])+$/.test(String(withoutEmojis).toLowerCase());
  }
  getValueWithoutEmojis(value) {
    return value.replace(
      /(?![*#0-9]+)[\p{Emoji}\p{Emoji_Modifier}\p{Emoji_Component}\p{Emoji_Modifier_Base}\p{Emoji_Presentation}]/gu,
      "",
    );
  }

  rejectCategoryCodeMaxLength = 5;
  rejectCategoryNameMaxLength = 100;
  rejectReasonCodeMaxLength = 5;
  rejectReasonNameMaxLength = 100;
  rejectCommentMaxLength = 300;

  isRejectCategoryCodeValid(value) {
    return /^[a-zA-Z0-9-_/|()[\]{}<>]+$/.test(String(value));
  }
  isRejectCategoryNameValid(value) {
    const withoutEmojis = this.getValueWithoutEmojis(value);
    if (value.length > 0 && withoutEmojis.length == 0) {
      return true;
    }
    return /^(?:(?![×Þß÷þø])[-_.,'\\/#%&| 0-9a-zÀ-ÿ()[\]{}<>œ…°])+$/.test(String(withoutEmojis).toLowerCase());
  }
  isRejectReasonCodeValid(value) {
    return /^[a-zA-Z0-9-_/|()[\]{}<>]+$/.test(String(value));
  }
  isRejectReasonNameValid(value) {
    const withoutEmojis = this.getValueWithoutEmojis(value);
    if (value.length > 0 && withoutEmojis.length == 0) {
      return true;
    }
    return /^(?:(?![×Þß÷þø])[-_.,'\\/#%&| 0-9a-zÀ-ÿ()[\]{}<>œ…°])+$/.test(String(withoutEmojis).toLowerCase());
  }

  productSkuMaxLength = 50;
  productNameMaxLength = 100;
  productCategoryMaxLength = 100;
  productConversionFactorMaxLength = 10;
  productObjectiveMaxLength = 5;

  isProductConversionFactorValid(value) {
    return /^(?=.{1,10}$)\d{1,10}(\.\d{1,8})?$/.test(value);
  }
  isProductRateObjectiveValueValid(value) {
    return /^[0-9]+(\.\d+)?$/.test(value);
  }
  isProductGiveawayObjectiveValueValid(value) {
    return /^[0-9]{1,9}([.]\d{0,3}){0,1}$/.test(value);
  }
  isProductTargetValueValid(value) {
    return /^[0-9]{1,5}([.]\d{0,3}){0,1}$/.test(value);
  }
  getProductAvailableTargetUnits() {
    return [
      { id: "kg", name: "kg" },
      { id: "lb", name: "lb" },
      { id: "g", name: "g" },
      { id: "oz", name: "oz" },
      { id: "L", name: "L" },
      { id: "mL", name: "mL" },
      { id: "m", name: "m" },
      { id: "ft", name: "ft" },
    ];
  }
  isProductTargetUnitValid(unitId) {
    const found = this.getProductAvailableTargetUnits().filter((u) => unitId === u.id);
    return found && found.length === 1;
  }

  userEmailMaxLength = 100;
  userDisplayNameMaxLength = 100;
  userPasswordMaxLength = 100;

  isUserEmailValid(value) {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      String(value).toLowerCase(),
    );
  }
  isUserDisplayNameValid(value) {
    return /^(?:(?![×Þß÷þø])[- '`0-9a-zÀ-ÿ])+$/.test(String(value).toLowerCase());
  }
  isUserPasswordValid(value) {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,16}$/.test(value);
  }

  isWorkShiftNameValid(value) {
    return /^(?:(?![×Þß÷þø])[-_ 0-9a-zÀ-ÿ])+$/.test(String(value).toLowerCase());
  }
}

export default new Validations();
